export const en = {
    'esli-u-vas-est-param-link': 'write to us about it',
    'operator-comment': 'Operator comment',
    'oshibki-ustraneny-nuzhna-povtornaya-100': 'Errors fixed. Ad should be re-checked',
    'ostalis-drugie-voprosy-po': 'Other questions about the service',
    'ostalis-voprosy-o-prichinah': "I still don't understand why my ad has been rejected",
    'ostavit-zayavku-na-vozvrat': 'Request a refund',
    'otpravit-dokumenty': 'Submit documents',
    'polnyy-spisok-trebovaniy': 'Full list of requirements',
    'popup-title': 'How can this be fixed',
    'ubedites-chto-reklamnye-materialy':
        'Make sure that ad materials follow {yandex} and {law}. Pay particular attention to the requirements for images, keywords, and sitelinks.',
    'ubedites-chto-reklamnye-materialy-param-law': 'current legislation',
    'ubedites-chto-reklamnye-materialy-param-yandex': 'Yandex advertising policy'
};
